import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { CourseList, CourseQueryFilter, CourseQueryFilterDefaultValues } from '../../course/course-list';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { NoResultsComponent } from '../../no-results/no-results.component';
import { CheckPageAccess } from '../../authorize/check-page-access';
import { CourseService } from 'src/app/services/course.service';
import { TagsService } from 'src/app/services/tag-service.service';
import { ApplicationProgramsService } from 'src/app/services/application-programs.service';
import { UpdateUser, UpdateUserDefaultValues } from '../update-user';
import { Course } from '../../course/course';

@Component({
    selector: 'app-user-course-list',
    templateUrl: './user-course-list.component.html',
    styleUrls: ['./user-course-list.component.scss'],
    standalone: false
})
export class UserCourseListComponent {
  courseList: CourseList[] = [];
  @Input() type: string = 'SPECIALPERMISSION';
  @Input() updateUser: UpdateUser = UpdateUserDefaultValues();
  selectedCourse: any[] = [];
  totalRecords: number = 0;
  columnsToDisplay = [
    'checkbox',
    'name',
    'id',
    'program'];
  //queryFilter:TagQueryFilter=TagQueryFilterDefaultValues();
  pageEvent!: PageEvent;
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild('noResults') noResults!: NoResultsComponent;
  @ViewChild('submitButton') submitButton !:ElementRef
  information: string = '';
  queryFilter: CourseQueryFilter = CourseQueryFilterDefaultValues();
  tags: any[] = [];
  coursePrograms: any[] = [];
  courseStatus: any[] = [];
  pageName = CheckPageAccess.USERMANAGEMENT

  constructor(public courseservice: CourseService,
    private tagservice: TagsService,
    private appprogservice: ApplicationProgramsService)
  {}

  async ngOnInit(): Promise<void> {
    this.information="<h4>Status Definitions</h4>"+
    "<br/><span>Draft:</span> Material is in progress and not yet finalized. It can be edited and is not visible to participants. It can be associated with a draft course.<br/><br/>"+
    "<span>Published:</span> Material is finalized and available for use in published courses. It can be edited if it is associated with draft courses or published courses with zero enrolments.<br/><br/>"+
    "<span>Retired:</span> Material is no longer actively used for new courses but remains accessible to users who started using it while it was in the published status. It cannot be edited.";

    await this.appprogservice.getCoursePrograms().subscribe({
      next: (data) => {
        this.coursePrograms=data;
      }
    });

    await this.tagservice.getActiveTags().subscribe({
      next: (data) => {
        this.tags=data;
      }
    });

    await this.courseservice.getCourseStatus().subscribe({
      next: (resp) => {
        this.courseStatus = resp
      }
    });

   this.searchWithFilters();
  }

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.queryFilter.PageNumber = e.pageIndex;
    this.queryFilter.PageSize = e.pageSize;
    this.searchWithFilters();
  }

  private searchWithFilters() {

    switch(this.type) {
      case 'SPECIALPERMISSION':
        this.courseservice.getSpecialPermissionCourses(this.queryFilter, this.updateUser.publicId).subscribe({
          next: (data) => {
            let headers = data.headers.get('x-pagination');
            if (headers) {
              let parsedHeaders = JSON.parse(headers);
              this.totalRecords = parsedHeaders.TotalCount;
              this.noResults.setTotal(this.totalRecords);
            }
            this.courseList = data.body ? data.body : [];
          },
          error: (error) => {
            console.log(error);
          },
          complete: () => {
            this.selectedCourse = this.updateUser.specialPermissions
           }
        });
        break;
      case 'RECOMMENDEDSESSION':
        this.courseservice.getRecommendedCourses(this.queryFilter, this.updateUser.publicId).subscribe({
          next: (data) => {
            let headers = data.headers.get('x-pagination');
            if (headers) {
              let parsedHeaders = JSON.parse(headers);
              this.totalRecords = parsedHeaders.TotalCount;
              this.noResults.setTotal(this.totalRecords);
            }
            this.courseList = data.body ? data.body : [];
          },
          error: (error) => {
            console.log(error);
          },
          complete: () => {
            this.selectedCourse = this.updateUser.recommendedSessions
           }
        });
        break;
    }
  }

  @HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent): void {
	  if (event.key === 'Enter') {
      this.submitButton.nativeElement.click();
      event.preventDefault();
	  }
	}

  resetFilters() {
    this.queryFilter = CourseQueryFilterDefaultValues();
    this.search();
  }

  search() {
    this.searchWithFilters();
  }

  onCheckboxChange(course: CourseList) {
    const index = this.selectedCourse.findIndex((m:any) => m.courseId === course.id);
    if (index === -1) {
      this.selectedCourse.push({courseId:course.id});
    } else {
      this.selectedCourse.splice(index, 1);
    }

    switch (this.type)
    {
      case 'SPECIALPERMISSION':
        this.updateUser.specialPermissions = this.selectedCourse;
        break;
      case 'RECOMMENDEDSESSION':
        this.updateUser.recommendedSessions = this.selectedCourse;
        break;
    }
  }

  isCourseSelected(course: CourseList): boolean {
    return this.selectedCourse.some((m:any) => m.courseId === course.id);
  }

}
